import { render, staticRenderFns } from "./sponsor-config-list.vue?vue&type=template&id=1ac71102&"
import script from "./sponsor-config-list.vue?vue&type=script&lang=js&"
export * from "./sponsor-config-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports